import {Circle} from './circle';

export class Ellipse extends Circle {
}
